import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import CourseAnalyticsLikesUI from '../view/CourseAnalyticsLikesUI';
import {useOutletContext, useParams} from 'react-router-dom';
import CourseAnalyticsLikesStore from '../store/CourseAnalyticsLikesStore';
import {MicroreelLikes} from '../../../../../data/models/Likes/LikeModel';
import {downloadCSV} from '../../../../../utils/downloadCsv';
import {analyticsText} from '../../../analyticsText';

interface Props {
  courseAnalyticsLikesStore?: CourseAnalyticsLikesStore;
}

const CourseAnalyticsLikesContainer = inject('courseAnalyticsLikesStore')(
  observer(({courseAnalyticsLikesStore}: Props) => {
    const [likes, setLikes] = useState<MicroreelLikes[]>([]);
    // True until the first likes response arrives (success or error).
    const [likesLoading, setLikesLoading] = useState(true);
    const [search, setSearch] = useState('');
    // Empty until a header is clicked, so the table opens in reel order
    const [sortBy, setSortBy] = useState('');
    const [sortAsc, setSortAsc] = useState(false);
    const {organizationId, courseId} = useParams();

    const [, courseName] = useOutletContext<[boolean, string, number]>();

    useEffect(() => {
      if (!organizationId || !courseId) return;
      courseAnalyticsLikesStore!
        .getCourseMicroreels(organizationId, courseId)
        .then(lessons => courseAnalyticsLikesStore!.getLikes(lessons))
        .then(data => {
          setLikes(data);
          setLikesLoading(false);
        });
    }, [organizationId, courseId]);

    const onChangeSort = (field: string, asc: boolean) => {
      setSortAsc(asc);
      setSortBy(field);
    };

    const onExport = () => {
      if (!likes.length) return;
      downloadCSV(
        [
          [analyticsText.microreel, analyticsText.likes],
          ...likes.map(reel => [reel.title, reel.totalLikes.toString()]),
        ],
        `${courseName}_likes.csv`,
      );
    };

    return (
      <CourseAnalyticsLikesUI
        organizationId={organizationId || ''}
        courseId={courseId || ''}
        likes={likes}
        isLoading={likesLoading}
        search={search}
        setSearch={setSearch}
        onExport={onExport}
        sortBy={sortBy}
        sortAsc={sortAsc}
        onChangeSort={onChangeSort}
      />
    );
  }),
);

export default CourseAnalyticsLikesContainer;
